import ArrowDown from "@mui/icons-material/KeyboardArrowDown";
import ArrowUp from "@mui/icons-material/KeyboardArrowUp";
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  SelectProps,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";
import { useApi } from "../../contexts/ApiContext";
import FormLabel from "../FormLabel";
import { InputProps } from "./InputProps";
const StyledSelect = styled(Select)`
  margin: 0px 0;
  padding: 0;
`;

export interface SelectFormInputOption {
  label: string;
  value: string;
}

export type SelectFormInputPropsType = InputProps & SelectProps;

export interface SelectFormInputProps
  extends Omit<SelectFormInputPropsType, "onChange"> {
  onChange: (value: string) => void;
  options: SelectFormInputOption[];
  caption?: string;
}

const SelectFormInput: React.FC<SelectFormInputProps> = ({
  label,
  value,
  onChange,
  error,
  helperText,
  options,
  caption,
  ...rest
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <FormControl disabled={isDisabled}>
      <FormLabel error={error}>{label}</FormLabel>
      {caption && (
        <Typography color={"greyButton"} variant={"caption"}>
          {caption}
        </Typography>
      )}
      <StyledSelect
        {...rest}
        disabled={isDisabled}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onChange={(ev: any) => onChange(ev.target.value)}
        IconComponent={() => (open ? <ArrowUp /> : <ArrowDown />)}
        error={error}
        value={value ?? null}
      >
        {options.map((option: SelectFormInputOption) => (
          <MenuItem
            key={option.value}
            selected={option.value === value}
            value={option.value}
          >
            {option.label}
          </MenuItem>
        ))}
      </StyledSelect>
      <FormHelperText error={error}>
        {helperText ? helperText : " "}
      </FormHelperText>
    </FormControl>
  );
};

export default SelectFormInput;
